module.exports = __webpack_public_path__ + "static/chas-bains-b12991f2a1578e2c2da36171f72a64ad.jpg";